import { buildSalesPaceCards } from './buildSalesPaceCards'
import { buildWeekdayUnderperformanceCards } from './buildWeekdayUnderperformanceCards'

/** @type {Record<string, (insight: import('./types').InsightRecord) => import('./types').RecommendationCardDraft[]>} */
const CARD_BUILDERS = {
  weekday_underperformance: buildWeekdayUnderperformanceCards,
  sales_pace: buildSalesPaceCards,
}

const INSIGHT_STATUS_TO_CARD_STATUS = {
  new: 'pending',
  accepted: 'approved',
  dismissed: 'dismissed',
  completed: 'executed',
}

const RECOMMENDATION_STATUS_MAP = {
  pending: 'pending',
  approved: 'approved',
  dismissed: 'dismissed',
  executed: 'executed',
}

/**
 * @param {import('./types').InsightRecord} insight
 * @returns {import('./types').RecommendationCard[]}
 */
export function buildRecommendationCardsForInsight(insight) {
  const insightType = insight.insight_type || ''
  const builder = CARD_BUILDERS[insightType]
  if (!builder) return []

  const insightId = String(insight.id)
  const defaultStatus =
    INSIGHT_STATUS_TO_CARD_STATUS[insight.status] || 'pending'
  const primaryRecommendation = insight.recommendations?.[0]
  const recommendationStatus = primaryRecommendation?.status
    ? RECOMMENDATION_STATUS_MAP[primaryRecommendation.status] || defaultStatus
    : defaultStatus

  return builder(insight)
    .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
    .map((draft, index) => ({
      ...draft,
      id: `${insightId}-${draft.displayOrder ?? index + 1}`,
      insightId,
      insightType,
      status: draft.recommendationId ? recommendationStatus : defaultStatus,
      recommendationId: draft.recommendationId || primaryRecommendation?.id,
    }))
}

/**
 * @param {import('./types').InsightRecord[]} insights
 * @returns {import('./types').RecommendationCard[]}
 */
export function buildRecommendationCardsForInsights(insights = []) {
  return insights.flatMap((insight) =>
    buildRecommendationCardsForInsight(insight)
  )
}

export { buildSalesPaceCards, buildWeekdayUnderperformanceCards }
export { formatConfidence, formatMoney } from './format'
